// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatBox_container__1--PQ","default":"ChatBox_default__18fxQ"};